<template>
  <keep-alive>
    <div id="menu-btn-active-drop-down" ref="switcherRef" class="dropdown">
      <div
        v-if="visible"
        id="switcher-backdrop"
        class="tw-fixed tw-top-[56px] tw-w-full tw-h-screen tw-z-[1] tw-left-0 tw-bg-[rgba(0,0,0,0.5)]"
        style="z-index: 3000"
        @click.stop="isMenuOpen = false"
      ></div>
      <button
        v-if="!isOrgSwitchLoading && currentOrg?.id"
        class="dropdown-btn"
        data-cy="switch-org-dropdown-btn"
        @click.stop="() => toggleMenu()"
        @keyup.esc="closeMenu"
      >
        <span v-if="!isOrgSwitchLoading" class="dropdown-btn-active">
          <GlobalAvatar
            v-if="currentParentOrg?.id"
            :name="currentParentOrg?.name"
            :src="currentParentOrg?.img"
            :class-name="'active-org-icon'"
          />
          <div v-if="currentParentOrg?.id" class="style__avatar"></div>
          <GlobalAvatar
            :name="currentOrg?.name"
            :src="currentOrg?.img"
            :class-name="'active-org-icon'"
          />
          <span class="!tw-truncate tw-max-w-[95px] !tw-inline-block">{{
            currentOrg?.name
          }}</span>
        </span>
        <span>
          <img
            v-if="isMenuOpen"
            class="tw-w-[10px] tw-h-[7px]"
            src="/img/up_arrow_dark.svg"
            alt="up_arrow"
          />
          <img
            v-else
            class="tw-w-[10px] tw-h-[7px]"
            src="/img/down_arrow_dark.svg"
            alt="down_arrow"
          />
        </span>
      </button>

      <div
        v-if="isOrgSwitchLoading || !currentOrg?.id"
        class="tw-w-full tw-flex tw-rounded-[6px] tw-bg-[#ffffff] tw-pl-[6px]"
      >
        <div class="tw-h-[38px] tw-w-[38px] tw-justify-end">
          <!-- eslint-disable vue/no-unused-refs -->
          <LottieAnimation
            ref="anim"
            :animation-data="ProgressAnimation"
            :auto-play="true"
            :loop="true"
          />
        </div>
      </div>
      <div
        v-show="isMenuOpen"
        :class="`dropdown__menu tw-pb-[15px] ${
          currentParentOrg?.id ? '' : 'tw-pt-[20px]'
        }`"
      >
        <!-- {{ currentParentOrg }} -->
        <div
          v-if="currentParentOrg?.id"
          class="tw-flex org-text tw-px-[15px] tw-py-[15px] tw-justify-between parent tw-cursor-pointer"
          @click="handleSelectOrg(currentParentOrg)"
        >
          <div class="tw-flex parent__avatar">
            <GlobalAvatar
              :name="currentParentOrg?.name"
              :src="currentParentOrg.img"
              :class-name="'org-icon'"
            />
            <div
              class="tw-text-[13px] tw-leading-5 tw-font-medium !tw-truncate tw-max-w-[130px] !tw-inline-block tw-mx-[10px] tw-items-center"
            >
              {{ currentParentOrg?.name }}
            </div>
          </div>
          <div>
            <img
              v-if="currentParentOrg?.isHome"
              src="/img/home_icon.svg"
              alt="home-icon"
              class="home-icon"
            />
          </div>
        </div>
        <div
          :class="`dropdown__menu__title ${
            currentParentOrg?.id
              ? 'dropdown__menu__title__parent'
              : 'dropdown__menu__title__no__parent'
          }`"
        >
          {{ getComponentUiText("app-org-switcher-title-1") }}
        </div>
        <div
          v-if="orgList.length > 2"
          id="search-box-org"
          class="tw-mx-[15px] tw-mt-2"
        >
          <BaseSearchbox
            :class="[
              'tw-relative tw-h-[36px] tw-rounded-[6px] tw-mb-2 tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#FFFFFF] tw-px-[15px] search-box',
            ]"
            input-style="tw-bg-[#FFFFFF] !tw-text-[12px] tw-mt-[1px]"
            :icon-search-style="'tw-scale-[0.867]'"
            :icon-close-style="'tw-scale-[0.8]'"
            :model-value="searchValue"
            :placeholder="getComponentUiText('app-header-search-prompt-1')"
            @update:model-value="actionsUpdateFilter"
            @on:focus="() => {}"
            @on:blur="() => {}"
            @keyup.enter="handleEnterSearch"
          />
        </div>

        <div v-if="orgList.length === 0">
          <div
            v-for="(item, index) in 3"
            :key="index"
            style="border-bottom: 1px solid #eff0f1"
            :class="`custom-global-skeleton tw-w-full tw-h-[50px] ${
              index !== 2 ? 'list__skeleton' : 'list__skeleton__last'
            }`"
          ></div>
        </div>
        <div v-else class="dropdown__menu__items">
          <div
            v-for="org in orgListData"
            :key="org.id"
            :style="`${
              currentParentOrg?.id ? '' : 'border-top: 1px solid #eff0f1'
            }`"
            class="dropdown__menu__item dropdown__menu__item__org"
            @click="() => handleSelectOrg(org)"
          >
            <span class="org_items">
              <img
                v-if="org.isHome && org.img"
                :src="org.img"
                alt="profilePicture"
                class="tw-w-[20px] tw-h-[20px] tw-rounded-[50%] profilePicture"
              />
              <GlobalAvatar
                v-else
                :name="org?.name"
                :src="org.img"
                :class-name="'org-icon'"
              />
              <span
                :data-cy="`${
                  org.id === currentOrg.id
                    ? 'current-org-true'
                    : 'current-org-false'
                }`"
                class="org-text org-text-name !tw-truncate tw-max-w-[120px]"
                >{{ org?.name }}</span
              >
              <span
                :class="`org-text org-text-legal !tw-truncate ${
                  org.id !== currentOrg.id
                    ? 'tw-max-w-[220px]'
                    : 'tw-max-w-[120px]'
                }`"
                >{{ org?.nameLegal }}</span
              >
              <img
                v-if="org.isHome"
                src="/img/home_icon.svg"
                alt="home-icon"
                class="home-icon"
              />
            </span>
            <span class="org-status">
              <span v-if="org.id === currentOrg.id" class="current-status">{{
                getComponentUiText("app-org-switcher-active-org-1")
              }}</span>
            </span>
          </div>
        </div>
        <!-- <div v-if="orgList.length > 0" class="divider" /> -->

        <div class="org__operations">
          <span>
            <button
              :class="`tw-bg-white tw-border-none tw-w-full ${
                isSubscriptionsInvalid || !orgPlanDetails?.planId
                  ? 'tw-pointer-events-none'
                  : ''
              }`"
              @click="() => showModal()"
            >
              <span class="dropdown__menu__item orgOperation">
                <span>{{
                  getComponentUiText("app-manage-orgs-heading-1")
                }}</span>
                <img src="/img/right_arrow_icon.svg" alt="right_arrow" />
              </span>
            </button>
          </span>

          <span>
            <button
              :class="`tw-bg-white tw-border-none tw-w-full ${
                isSubscriptionsInvalid || !orgPlanDetails?.planId
                  ? 'tw-pointer-events-none'
                  : ''
              }`"
              @click="() => openCreateOrgModal()"
            >
              <span class="dropdown__menu__item orgOperation">
                <span>{{
                  getComponentUiText("app-org-switcher-create-org-1")
                }}</span>
                <img src="/img/right_arrow_icon.svg" alt="right_arrow" />
              </span>
            </button>
          </span>
        </div>
      </div>
      <Modal
        :visible="isShow"
        :max-width="70"
        :close-on-esc="!(modal === ModalTypes.CreateOrg)"
        :style-modal="`${
          modal === ModalTypes.CreateOrg ? '!tw-max-h-[680px]' : ''
        }`"
        @close="closeModal"
      >
        <ManageOrgDropDown
          :model-value="isShow"
          :update-modal="updateModal"
          :search-key="searchKey"
          @close-modal="closeModal"
          @leave-org="openLeaveModal"
          @create-org="
            ({ data, mode }) => {
              modal = ModalTypes.CreateOrg;
              orgDataEdit = data;
              modalType = mode;
            }
          "
        />
      </Modal>
      <ManageUserModal
        :show="showModalLeaveOrg"
        :header="false"
        :red-btn="true"
        contain-title="app-manage-orgs-leave-org-header-modal-1"
        contain-sub-title="app-manage-orgs-leave-org-modal-leave-action-helper-1"
        action-title="app-manage-orgs-leave-org-header-modal-1"
        @update:show="showModalLeaveOrg = $event"
        @update:action-handle="onLeaveOrg"
      />
      <div
        v-show="modal === ModalTypes.CreateOrg"
        role="dialog"
        tabindex="-2"
        aria-modal="true"
        aria-label="Modal window"
        v-bind="$attrs"
        class="v-modal"
        :style="styleClass"
        @click="() => (modal = null)"
      />
    </div>
  </keep-alive>
  <CreateOrgModal
    v-if="modal === ModalTypes.CreateOrg"
    :show="modal === ModalTypes.CreateOrg"
    :org-data="orgDataEdit"
    :type="modalType"
    :hide-overlay="false"
    class="tw-z-[2000]"
    @update:show="setModal"
  />
</template>

<script lang="ts" setup>
import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { ref, watch, computed, onMounted, onBeforeUnmount, Ref } from "vue";
import { getComponentUiText, getImageData } from "@/utils/utilities";
import ManageOrgDropDown from "./manageOrgDropDown.vue";
import Modal from "@/components/common/modal.vue";
import { useRoute, useRouter } from "vue-router";
import {
  INDEX_PRIMARY_PAGE,
  localStorageBoolean,
  localStorageKey,
  ModalTypes,
  requestAccessDetailModalType,
} from "@/utils/constants";
import CreateOrgModal from "@/components/orgManagement/createOrgModal.vue";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import { getOrgIdProfile, leaveOrg } from "@/services/org";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { IModalMessage } from "@/interfaces/common/common";
import { MODAL_NAME } from "@/utils/constants";
import { onUnmounted } from "vue";
import GlobalAvatar from "@/components/common/globalAvatar.vue";
import { getProfileImage } from "@/services/org";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import { debounce } from "lodash";

export type orgItem = {
  id: number;
  name: string;
  icon: string;
  isHome: boolean;
};
const props = defineProps({
  statusSetupModal: {
    type: Boolean,
    required: false,
    default: false,
  },
  userData: {
    type: Object,
    required: true,
  },
});

// Define your reactive data and refs
const currentParentOrg = computed(() => store.state.Org.currentParentOrg);
const isOrgSwitchLoading: Ref<boolean> = ref(false);
const isMenuOpen = ref(false);
const isSubscriptionsInvalid = ref(false);
let showModalLeaveOrg = ref(false);
let updateModal = ref(false);
const isShow = ref(false);
const searchKey = ref("");
const visible = ref(false);
const switcherRef = ref<HTMLDivElement | null>(null);
let orgSelected = "";
const styleClass = {
  background: "rgb(0, 0, 0, 0)",
  "border-radius": "6px",
};
const searchValue: Ref<string> = ref("");

const orgPlanDetails = computed(() => store.getters["Org/getPlanDetails"]);

watch(
  () => orgPlanDetails.value,
  () => {
    if (!orgPlanDetails.value || !orgPlanDetails.value.planId) {
      isSubscriptionsInvalid.value = true;
    } else {
      isSubscriptionsInvalid.value = false;
    }
  },
);

watch(
  () => props.userData,
  async (value) => {
    if (value && value.userId) {
      await store.dispatch("Org/fetchOrgList", value);
    }
  },
);

const currentOrg = computed(() => store.getters["Org/getCurrentOrg"]);
const orgList = computed(() => {
  if (isSubscriptionsInvalid.value) {
    return store.state.Org.orgsList.filter(
      (org) => org.id === currentOrg.value.id || org.isHome,
    );
  }
  return store.state.Org.orgsList;
});
const orgListData = ref<any[]>([]);
const originOrgsList = computed(() => store.state.Org.originOrgsList);
const modal = ref(null) as Ref<ModalTypes | null>;
const modalType = ref<keyof typeof requestAccessDetailModalType>(
  requestAccessDetailModalType.createRequest,
);
const orgDataEdit = ref<any>();
let selectedOrgModal = ref(-1);
let typeOfAction = "";
const typeOfActionData = {
  switchOrg: "switchOrg",
  create: "create",
  manageOrg: "manageOrg",
};
const setModal = (val) => {
  modal.value = val;
  history.state.modal = val;
};

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (oldValue.id && newValue.id && newValue.id !== oldValue.id) {
      store.dispatch("Org/fetchOrgRoles");
    }
  },
);

watch(
  () => orgList.value,
  (value) => {
    orgListData.value = value;
  },
  { immediate: true },
);

const isDirtySetup = computed(() => {
  return store.getters["SetupWizard/isDirty"];
});

// Define your component methods
const closeModal = () => {
  isShow.value = false;
  closeMenu();
};
const emit = defineEmits(["update:show"]);

const showModal = (ischeckSetup = true) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.manageOrg;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
      setTimeout(() => {
        store.dispatch("Overlay/showOverlay");
      }, 100);
    }
  }
  if (!ischeckSetup) {
    setTimeout(() => {
      store.dispatch("Overlay/showOverlay");
    }, 100);
  }
  if (currentOrg.value.id !== 0) {
    isMenuOpen.value = false;
    isShow.value = true;
  }
};

const closeMenu = () => {
  isMenuOpen.value = false;
  EventEmitter.emit("setZIndexIConNavBar", false);
};

const openLeaveModal = (orgId) => {
  updateModal.value = false;
  selectedOrgModal.value = orgId;
  showModalLeaveOrg.value = true;
};

const emitStatus = () => {
  if (!props.statusSetupModal) {
    if (isMenuOpen.value) store.dispatch("Overlay/showOverlay");
    else store.dispatch("Overlay/hideOverlay");
  } else {
    if (isMenuOpen.value) visible.value = true;
    else visible.value = false;
  }
};

const onLeaveOrg = async () => {
  try {
    await leaveOrg(selectedOrgModal.value);
    store.dispatch("Org/fetchOrgList");
    updateModal.value = true;
    showModalLeaveOrg.value = false;
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.leaveOrg);
    }
  }
};

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
  if (isMenuOpen.value) {
    EventEmitter.emit("setZIndexIConNavBar", true);
    EventEmitter.emit(EmitterEvents.CLOSE_ALL_POPOVERS, true);
  } else {
    EventEmitter.emit("setZIndexIConNavBar", false);
  }
};

const handleSelectOrg = async (org: any, ischeckSetup = true) => {
  searchValue.value = "";
  orgListData.value = orgList.value;
  const isHomeOrg = org?.isHome;
  store.commit("Recommend/REMOVE_SELECTED_ASSESSMENT_QUESTIONS");
  if (org.id === currentOrg.value.id) {
    isMenuOpen.value = false;
    return;
  }
  store.commit("Org/SET_STATUS_CALL_API_CHECK_PARENT", false);
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.switchOrg;
      orgSelected = org;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    }
  }
  isOrgSwitchLoading.value = true;
  isMenuOpen.value = false;
  const res = await store.dispatch("Org/switchOrg", {
    orgId: org.id,
    isHomeOrg,
  });
  if (res) {
    isOrgSwitchLoading.value = false;
    store.dispatch("Recommend/fetchChecklistData");
    store.dispatch("Scanning/fetchScanHistoryWebServices");
    store.dispatch("Scanning/fetchScanHistoryDomains");
  } else {
    store.commit("Org/SET_CURRENT_PARENT_ORG", {});
    store.commit("Org/SET_ORGS_LIST", []);
    for (const org of originOrgsList.value) {
      const paramOrgId = org.id == currentOrg.value.orgId ? null : org.id;
      if (org?.profileData?.avatarImageId) {
        const res = await getProfileImage(
          org.profileData.avatarImageId,
          paramOrgId,
        );
        const imageDetails = res.data.data;
        const imgBlob = await getImageData(imageDetails);
        org.img = URL.createObjectURL(imgBlob);
      }
    }
    const parent = JSON.parse(
      localStorage.getItem(localStorageKey.currentOrgData) || "{}",
    );
    if (parent?.idParentOrg) {
      try {
        const currentParentOrg = originOrgsList.value.find(
          (org) => org.id === parent.idParentOrg,
        );
        const listOrg = originOrgsList.value.filter(
          (org) => org.id !== parent.idParentOrg,
        );
        const profileParent = await getOrgIdProfile(currentParentOrg.id);
        if (profileParent.status == 200) {
          const data = profileParent.data.data;
          if (
            data?.logosm?.logoSmImageFileId ||
            data?.logolg?.logoLgImageFileId ||
            data?.avatar?.avatarImageFileId
          ) {
            const res = await getProfileImage(
              data?.logosm?.logoSmImageFileId ||
                data?.logolg?.logoLgImageFileId ||
                data?.avatar?.avatarImageFileId,
              data?.orgId,
            );
            const imageDetails = res.data.data;
            const imgBlob = await getImageData(imageDetails);
            currentParentOrg.imgLogo = URL.createObjectURL(imgBlob);
          }
        }
        store.commit("Org/SET_CURRENT_PARENT_ORG", currentParentOrg);
        store.commit("Org/SET_ORGS_LIST", listOrg);
      } catch (error) {
        showErrorAPI(error, Org.getOrgIdProfile);
      }
    } else {
      store.commit("Org/SET_ORGS_LIST", originOrgsList.value);
      store.commit("Org/SET_CURRENT_PARENT_ORG", {});
    }
    store.commit("Org/SET_STATUS_CALL_API_CHECK_PARENT", true);
    isOrgSwitchLoading.value = false;
  }

  EventEmitter.emit(EmitterEvents.EVENT_KEYBOARD_ESC);
};

const route = useRoute();
const router = useRouter();

const openCreateOrgModal = (ischeckSetup = true) => {
  const cond = document.getElementById("pricing-table-container");
  if (cond) {
    return;
  }
  if (props.statusSetupModal && ischeckSetup) {
    if (isDirtySetup.value) {
      typeOfAction = typeOfActionData.create;
      // changing, show modal
      const emitData: IModalMessage = {
        component: MODAL_NAME.MODAL_WIZARD_SAVE_EXIT,
        properties: {
          isMoreInfoModal: true,
          isAnswered: false,
          fromActiveOrg: true,
        },
      };
      EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
      return;
    } else {
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    }
  }
  EventEmitter.emit(
    EmitterEvents.SET_PRIMARY_MENU_INDEX,
    INDEX_PRIMARY_PAGE.setting,
  );
  router.push({
    name: "ManageAccess",
    query: { isOpenCreateModal: localStorageBoolean.true },
  });
  toggleMenu();
  if (route.name === "ManageAccess") {
    location.reload();
  }
};

const onClickOutside = (event: Event) => {
  const cond = document.getElementById("pricing-table-container");
  const searchBiox = document.getElementById("search-box-org");
  if (cond || searchBiox) {
    return;
  }
  if (!switcherRef.value?.contains(event.target as HTMLDivElement)) {
    isMenuOpen.value = false;
  }
};

// Watch for changes in isMenuOpen

watch(isMenuOpen, emitStatus);
onMounted(() => {
  EventEmitter.on("saveAndExitDone", (isCloseWiard) => {
    if (isCloseWiard) {
      isMenuOpen.value = false;
      return;
    }
    EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
    switch (typeOfAction) {
      case typeOfActionData.switchOrg:
        handleSelectOrg(orgSelected, false);
        break;
      case typeOfActionData.create:
        openCreateOrgModal(false);
        break;
      case typeOfActionData.manageOrg:
        showModal(false);
        break;
      default:
        break;
    }
  });
  EventEmitter.on("active-org-dropDown-close-dropdown", (value) => {
    isMenuOpen.value = value ? true : false;
  });
  window.addEventListener("click", onClickOutside);
});

onBeforeUnmount(() => {
  window.removeEventListener("click", onClickOutside);
});

onUnmounted(() => {
  EventEmitter.off("saveAndExitDone");
  EventEmitter.off("active-org-dropDown-close-dropdown");
});

onMounted(() => {
  EventEmitter.on(
    EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
    (value) => {
      if (value) {
        searchKey.value = typeof value === "string" ? value : "";
        showModal();
      } else {
        closeModal();
      }
    },
  );
  EventEmitter.on(EmitterEvents.PAGE_LOADING_COMPLETED, (value) => {
    isOrgSwitchLoading.value = value ? true : false;
  });
});

const actionsUpdateFilter = debounce((value: string) => {
  searchValue.value = value;
  handleFilter();
}, 300);

const handleFilter = () => {
  if (!searchValue.value) {
    orgListData.value = orgList.value;
    return;
  }
  // filter orglist follow item.name or item.nameLegal
  orgListData.value = orgList.value.filter((item) => {
    const name = item.name?.toLowerCase() || "";
    const nameLegal = item.nameLegal?.toLowerCase() || "";
    const search = searchValue.value.toLowerCase();
    return name.includes(search) || nameLegal.includes(search);
  });
};

const handleEnterSearch = () => {
  if (searchValue.value) {
    if (orgListData.value.length !== 1) return;
    handleSelectOrg(orgListData.value[0]);
    searchValue.value = "";
  }
};
</script>

<style scoped lang="scss">
.dropdown {
  position: relative;
  display: inline-block;
  width: 203px;
}
.style__avatar {
  width: 1px;
  align-self: stretch;
  background: var(--UI-rule, #eff0f1);
}
.dropdown-btn {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 5px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  max-width: 203px;
}

.dropdown-btn-active {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  font-size: 12px;
}

.dropdown-btn-active span {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  color: #211f58;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dropdown__menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 7px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 150%;
  min-width: 280px;
  margin-top: 5px;
}

.dropdown__menu__title {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  min-width: 116px;
  line-height: 100%;
  /* identical to box height, or 10px */

  text-transform: uppercase;
  letter-spacing: 0.1em;

  /* UI/dark-grey */

  color: #878787;
}
.dropdown__menu__title__parent {
  display: flex;
  padding: 10px 15px;
  align-items: flex-start;
  gap: 10px;

  border-top: 1px solid var(--UI-rule, #eff0f1);
  border-bottom: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}
.dropdown__menu__title__no__parent {
  padding: 0 15px 10px;
}
.dropdown__menu__items {
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow: auto;
  .dropdown__menu__item {
    &:hover {
      .org_items {
        .org-text-legal {
          display: inline-block;
        }
        .org-text-name {
          display: none;
        }
      }
    }
  }
}

.dropdown__menu__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  cursor: pointer;
  padding: 20px 15px 20px 0px;
  width: 100%;
  height: 50px;
}
.dropdown__menu__item__org {
  border-bottom: 1px solid #eff0f1;
}
.dropdown__menu__item:hover {
  background: rgba(239, 240, 241, 0.5);
}

.org_items {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 15px;
  .org-text-legal {
    display: none;
  }
  .org-text-name {
    display: inline-block;
  }
}

.org_items .org-text {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  height: 20px;
  font-size: 13px;

  color: #211f58;
}

.dropdown__menu__item:hover .org-text {
  color: #387dff;
}
.parent:hover {
  background: rgba(239, 240, 241, 0.5);
  color: #387dff;
}
.parent {
  line-height: 20px;
  height: 50px;
}

.home-icon {
  width: 12px;
  height: 12px;
}

.org-status {
  display: flex;
  align-items: center;
  gap: 10px;
}

.current-status {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 100%;
  /* identical to box height, or 10px */

  letter-spacing: 0.1em;
  text-transform: uppercase;

  /* brand/Dark Sky */

  min-width: 55px;
  height: 20px;
  color: #387dff;
  background: #ffffff;

  padding: 5px 6px;
  border: 1px solid #eff0f1;
  border-radius: 2px;
}

.divider {
  border-top: 1px solid #eff0f1;
  margin: 0px;
}

.org__operations {
  padding-top: 15px;
}

.orgOperation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px;
  height: 12px;

  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  /* identical to box height, or 12px */

  /* brand/Navy */

  color: #211f58;
}

.signout {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  height: 12px;
  line-height: 100%;
  /* identical to box height, or 12px */

  /* brand/Orange */

  color: #f7553c;
}

.modal-manage-width {
  max-width: 60rem !important;
}
.list__skeleton {
  border-bottom: 2px solid #eff0f1;
}
</style>

<style>
.active-org-icon {
  width: 23px !important;
  height: 23px !important;
  &&& > span {
    font-size: 6.5px;
  }
}
.org-icon {
  width: 20px !important;
  height: 20px !important;
  &&& > span {
    font-size: 6.5px;
  }
}
.isSubscriptionsInvalid {
  pointer-events: unset !important;
}
</style>
